import { Link, useLocation } from "react-router-dom";
import { categoryMap, categories } from "@/mocks/categories";
import { articlesBySlug } from "@/mocks/articles";

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);

  const items: { label: string; href?: string }[] = [{ label: "首页", href: "/" }];

  if (pathSegments[0] === "category" && pathSegments[1]) {
    const cat = categoryMap[pathSegments[1]];
    items.push({
      label: cat ? cat.name : pathSegments[1],
    });
  } else if (pathSegments[0] === "article" && pathSegments[1]) {
    const article = articlesBySlug[pathSegments[1]];
    if (article) {
      const cat = categories.find((c) => c.id === article.categoryId);
      if (cat) {
        items.push({ label: cat.name, href: `/category/${cat.slug}` });
      }
      items.push({ label: article.title });
    } else {
      items.push({ label: "文章详情" });
    }
  } else if (pathSegments[0] === "about") {
    items.push({ label: "关于我们" });
  }

  if (items.length <= 1) return null;

  return (
    <nav aria-label="Breadcrumb" className="max-w-7xl mx-auto px-4 md:px-6 pt-20 pb-2">
      <ol className="flex items-center gap-1.5 text-xs text-foreground-500 flex-wrap">
        {items.map((item, idx) => (
          <li key={idx} className="flex items-center gap-1.5">
            {idx > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400" />
            )}
            {item.href ? (
              <Link
                to={item.href}
                className="hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700 font-medium line-clamp-1 max-w-[300px]">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}